/* empty css                              */
import e from "./td-longtail-vue-components98.js";
const t = {
  name: "ProductOfferShadow"
};
var n = function() {
  var r = this, o = r._self._c;
  return o("div", { staticClass: "product-offer-shadow" });
}, a = [], s = /* @__PURE__ */ e(
  t,
  n,
  a,
  !1,
  null,
  "7237d66d"
);
const d = s.exports;
export {
  d as default
};
